import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const caseStudies = [
{
  id: 1,
  title: "24/7 Customer Support for E-commerce Brand",
  description: "How our AI chatbot reduced response times by 85% and increased customer satisfaction",
  industry: "E-commerce",
  results: "85% faster response times",
  imageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80"
},
{
  id: 2,
  title: "Medical Appointment Scheduling Automation",
  description: "Streamlining patient scheduling and reducing no-shows with AI voice assistants",
  industry: "Healthcare",
  results: "68% reduction in no-shows",
  imageUrl: "https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80"
},
{
  id: 3,
  title: "Real Estate Lead Qualification System",
  description: "AI-powered solution that pre-qualifies prospects and schedules viewings automatically",
  industry: "Real Estate",
  results: "3.2x increase in qualified leads",
  imageUrl: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80"
}];


export default function CaseStudySection() {
  return (
    <section className="py-16 bg-gray-50" data-id="dphlm0d7a" data-path="src/components/home/CaseStudySection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="fmm36xnqw" data-path="src/components/home/CaseStudySection.tsx">
        <div className="mb-12" data-id="2f5bt7eeg" data-path="src/components/home/CaseStudySection.tsx">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between" data-id="wolksb0yv" data-path="src/components/home/CaseStudySection.tsx">
            <div data-id="qj27w8fz0" data-path="src/components/home/CaseStudySection.tsx">
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="l0t8ekumt" data-path="src/components/home/CaseStudySection.tsx">
                Client Success Stories
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl" data-id="18ffrobjo" data-path="src/components/home/CaseStudySection.tsx">
                See how our AI automation solutions have transformed businesses across industries,
                delivering measurable results and significant efficiency gains.
              </p>
            </div>
            <div className="mt-4 lg:mt-0" data-id="rkxigr1sj" data-path="src/components/home/CaseStudySection.tsx">
              <Button asChild variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50" data-id="4yh1o0ggf" data-path="src/components/home/CaseStudySection.tsx">
                <Link to="/case-studies" className="flex items-center" data-id="7g26spdzy" data-path="src/components/home/CaseStudySection.tsx">
                  View all case studies <ArrowRight className="ml-2 h-4 w-4" data-id="3nty42llb" data-path="src/components/home/CaseStudySection.tsx" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="iyzwacqm1" data-path="src/components/home/CaseStudySection.tsx">
          {caseStudies.map((study) =>
          <Card key={study.id} className="overflow-hidden border-0 shadow-lg hover:shadow-xl transition-shadow" data-id="tgy29xaof" data-path="src/components/home/CaseStudySection.tsx">
              <div className="h-48 overflow-hidden" data-id="0m0afnf3h" data-path="src/components/home/CaseStudySection.tsx">
                <img
                src={study.imageUrl}
                alt={study.title}
                className="w-full h-full object-cover transition-transform hover:scale-105 duration-500" data-id="9b4t6y8lq" data-path="src/components/home/CaseStudySection.tsx" />

              </div>
              <CardContent className="p-6" data-id="2bkimh9pb" data-path="src/components/home/CaseStudySection.tsx">
                <div className="flex items-center mb-4" data-id="drv89hnqf" data-path="src/components/home/CaseStudySection.tsx">
                  <span className="text-sm font-medium text-purple-600 bg-purple-50 px-3 py-1 rounded-full" data-id="wnwgyvu9e" data-path="src/components/home/CaseStudySection.tsx">
                    {study.industry}
                  </span>
                  <span className="text-sm font-medium text-green-600 bg-green-50 px-3 py-1 rounded-full ml-2" data-id="ezjf1clet" data-path="src/components/home/CaseStudySection.tsx">
                    {study.results}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="ndi09ul5p" data-path="src/components/home/CaseStudySection.tsx">{study.title}</h3>
                <p className="text-gray-600 mb-4" data-id="xvp0b51cq" data-path="src/components/home/CaseStudySection.tsx">{study.description}</p>
                <Button variant="ghost" className="text-gray-400 p-0 cursor-not-allowed group" disabled data-id="c7pe4o9q2" data-path="src/components/home/CaseStudySection.tsx">
                  <span className="flex items-center" data-id="2q4mdmswe" data-path="src/components/home/CaseStudySection.tsx">
                    Read case study 
                    <ArrowRight className="ml-1 h-4 w-4" data-id="7jblabhmh" data-path="src/components/home/CaseStudySection.tsx" />
                  </span>
                </Button>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

}